import { FC } from "react";

export const LogoIcon: FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="1000"
    height="1000"
    viewBox="0 0 1000 1000"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="AxOrigin brand icon"
    role="img"
    {...props}
  >
    <title>AxOrigin brand icon</title>
    <circle cx="500" cy="500" r="500" fill="url(#paint0_linear_1_8)" />
    <g clipPath="url(#clip0_1_8)">
      <path
        d="M781.25 289.062C683.369 315.312 606.128 335.938 500 335.938C393.872 335.938 316.631 315.312 218.75 289.062L195.312 363.77C265.625 393.843 336.978 415.273 410.938 441.699L335.938 851.562L418.555 875L485.352 617.188H514.648L581.445 875L664.062 851.562L589.062 441.699C662.978 417.866 734.375 393.843 804.688 365.234L781.25 289.062Z"
        fill="white"
      />
      <path
        d="M500 289.062C483.776 289.062 467.916 284.251 454.426 275.238C440.936 266.224 430.422 253.413 424.213 238.423C418.004 223.434 416.38 206.94 419.545 191.028C422.71 175.115 430.523 160.499 441.995 149.026C453.467 137.554 468.084 129.741 483.996 126.576C499.909 123.411 516.403 125.036 531.392 131.244C546.381 137.453 559.193 147.967 568.206 161.457C577.22 174.947 582.031 190.807 582.031 207.031C582.008 228.78 573.358 249.632 557.979 265.01C542.6 280.389 521.749 289.039 500 289.062Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_8"
        x1="878.5"
        y1="889"
        x2="113"
        y2="115"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2563EB" />
        <stop offset="0.5" stopColor="#1D4ED8" />
        <stop offset="1" stopColor="#1E40AF" />
      </linearGradient>
      <clipPath id="clip0_1_8">
        <rect
          width="750"
          height="750"
          fill="white"
          transform="translate(125 125)"
        />
      </clipPath>
    </defs>
  </svg>
);
